export const TAG_COLOR_OPTIONS = [
  { id: 'backoffice', label: 'Backoffice' },
  { id: 'lavender', label: 'Lavender' },
  { id: 'peach', label: 'Peach' },
  { id: 'emerald', label: 'Emerald' },
  { id: 'sky', label: 'Sky' },
  { id: 'amber', label: 'Amber' },
  { id: 'blue', label: 'Blue' },
  { id: 'rose', label: 'Rose' },
  { id: 'neutral', label: 'Neutral' },
] as const;

export type TagColor = (typeof TAG_COLOR_OPTIONS)[number]['id'];

export const DEFAULT_TAG_COLOR: TagColor = 'backoffice';

const TAG_COLOR_CLASS_NAMES: Record<TagColor, string> = {
  backoffice: 'bg-backoffice-50 text-backoffice-800 border-backoffice-100',
  lavender: 'bg-lavender-50 text-lavender-800 border-lavender-100',
  peach: 'bg-peach-50 text-peach-800 border-peach-100',
  emerald: 'bg-emerald-50 text-emerald-800 border-emerald-100',
  sky: 'bg-sky-50 text-sky-800 border-sky-100',
  amber: 'bg-amber-50 text-amber-800 border-amber-100',
  blue: 'bg-blue-50 text-blue-800 border-blue-100',
  rose: 'bg-rose-50 text-rose-800 border-rose-100',
  neutral: 'bg-neutral-100 text-neutral-700 border-neutral-200',
};

export function isTagColor(value: string | null | undefined): value is TagColor {
  return TAG_COLOR_OPTIONS.some((option) => option.id === value);
}

export function resolveTagColor(value: string | null | undefined): TagColor {
  return isTagColor(value) ? value : DEFAULT_TAG_COLOR;
}

export function getTagColorClassName(value: string | null | undefined): string {
  return TAG_COLOR_CLASS_NAMES[resolveTagColor(value)];
}
